// components/calculator/FinalAmountAdjuster.js
import React from 'react';
import {
  Paper,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box
} from '@mui/material';

const FinalAmountAdjuster = ({ montoFinalDeseado, setMontoFinalDeseado, ajustarMontoFinal }) => {
  return (
    <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            🎯 Ajustar Monto Final
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Modifica el monto final y se recalcularán automáticamente todos los porcentajes manteniendo las proporciones.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField
              type="number"
              label="Monto Final Deseado"
              value={montoFinalDeseado}
              onChange={(e) => setMontoFinalDeseado(e.target.value)}
              placeholder="Ej: 180000"
            />
            <Button variant="contained" onClick={ajustarMontoFinal}>
              ⚡ Ajustar
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Paper>
  );
};

export default FinalAmountAdjuster;